import { RegionProfileService } from './../../region-profile.service';
import { IRegion } from './../../../_models/account/IRegion';
import { IPaged } from '../../../_models/common/IPaged';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  region$: Observable<IRegion>;

  constructor(
    private regionProfileService: RegionProfileService,) { }

  ngOnInit(): void {
    this.region$ = this.regionProfileService.region$;
  }
}